import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../store/index.js";
import { isSpecialLandingDownloadHost } from "@/util/lm-download";

Vue.use(VueRouter);

let homeRoute;

if (location.hostname.split(".").includes("syyacheng")) {
  homeRoute = {
    path: "/",
    component: () => import("../views/liveMatches/index.vue"),
  };
} else {
  homeRoute = {
    path: "/",
    redirect: isSpecialLandingDownloadHost() ? "/download" : "/home",
  };
}

const defaultRedirect = "/home";

const routes = [
  homeRoute,
  {
    path: "/urgent",
    component: () => import("../views/urgent/index.vue"),
    meta: {
      title: "紧急公告",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/home.vue"),
    meta: {
      title: "首页",
      type: "login", // 是否需要判断是否登录,这里是需要判断
    },
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("../views/test/test.vue"),
  // },
  {
    path: "/liveMatches",
    name: "liveMatches",
    meta: {
      title: "直播",
      type: "login",
    },
    component: () => import("../views/liveMatches/index.vue"),
  },
  {
    path: "/liveMatchesReplay",
    name: "liveMatchesReplay",
    component: () => import("../views/liveMatches/index.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/index.vue"),
  },
  {
    path: "/news_detail/:id",
    name: "news_detail",
    component: () => import("../views/news/news_detail.vue"),
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/notice/index.vue"),
  },
  {
    path: "/protocol/:id/:channel",
    name: "protocol",
    component: () => import("../views/protocol/index.vue"),
  },
  {
    path: "/privacy/:id",
    name: "privacy",
    component: () => import("../views/protocol/privacy.vue"),
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("../views/activity/index.vue"),
  },
  {
    path: "/activity_details/:id",
    name: "activity_details",
    component: () => import("../views/activity/activity_details.vue"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("../views/game/index.vue"),
  },
  {
    path: "/monopoly",
    name: "monopoly",
    component: () => import("../views/game/monopoly.vue"),
  },
  {
    path: "/sieve",
    name: "sieve",
    component: () => import("../views/game/sieve.vue"),
  },
  {
    path: "/gameDetail/:url",
    name: "gameDetail",
    component: () => import("../views/game/gameDetail.vue"),
  },
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("../views/schedule/index.vue"),
  },
  {
    path: "/schedule-preview",
    name: "schedule-preview",
    component: () => import("../views/schedule-preview/index.vue"),
  },
  {
    path: "/scheduleDetail/:id/:sportId",
    name: "scheduleDetail",
    component: () => import("../views/schedule/scheduleDetail.vue"),
  },
  {
    path: "/worldCup",
    name: "worldCup",
    component: () => import("../views/worldCup/index.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () => import("../views/download/index.vue"),
  },
  {
    path: "/about/:id",
    name: "about",
    component: () => import("../views/about/index.vue"),
  },
  {
    path: "/keysearch",
    name: "keysearch",
    component: () => import("../views/keysearch/index.vue"),
  },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("../views/login/index.vue"),
  // },
  {
    path: "/liveMatchesTwo/:id",
    name: "liveMatchesTwo",
    // meta: {
    //   title: "直播间",
    //   type: "login",
    // },
    component: () => import("../views/liveMatchesTwo/index.vue"),
  },
  {
    path: "/user-center/index",
    name: "user-center",
    component: () => import("../views/user-center/index.vue"),
  },
  {
    path: "/user-center/apply-anchor",
    name: "apply-anchor",
    component: () => import("../views/user-center/apply-anchor.vue"),
  },
  {
    path: "/user-center/myWallet",
    name: "myWallet",
    component: () => import("../views/user-center/myWallet.vue"),
  },
  {
    path: "/user-center/center-anchor",
    name: "center-anchor",
    component: () => import("../views/user-center/center-anchor.vue"),
  },
  {
    path: "/user-center/live-room-settings",
    name: "live-room-settings",
    component: () => import("../views/user-center/live-room-settings.vue"),
  },
  {
    path: "/user-center/guessing-management",
    name: "guessing-management",
    component: () => import("../views/user-center/guessing-management.vue"),
  },
  {
    path: "/user-center/focus",
    name: "focus",
    component: () => import("../views/user-center/focus.vue"),
  },
  {
    path: "/user-center/mySchedule",
    name: "mySchedule",
    component: () => import("../views/user-center/mySchedule.vue"),
  },
  {
    path: "/user-center/watchHistory",
    name: "watchHistory",
    component: () => import("../views/user-center/watchHistory/index.vue"),
  },
  {
    path: "/user-center/betHistory",
    name: "betHistory",
    component: () => import("../views/user-center/betHistory/index.vue"),
  },{
    path: "/user-center/voucher",
    name: "voucher",
    component: () => import("../views/user-center/voucher/index.vue"),
  },
  {
    path: "/user-center/rechargeHistory",
    name: "rechargeHistory",
    component: () => import("../views/user-center/rechargeHistory/index.vue"),
  },
  {
    path: "/user-center/recharge",
    name: "recharge",
    component: () => import("../views/user-center/recharge/index.vue"),
  },
  {
    path: "/user-center/checkin",
    name: "checkin",
    component: () => import("../views/user-center/checkin/index.vue"),
  },
  {
    path: "/user-center/privateChat",
    name: "privateChat",
    component: () => import("../views/user-center/privateChat/index.vue"),
  },
  {
    path: "/user-center/live-management",
    name: "liveManagement",
    component: () => import("../views/user-center/live-management.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/help/index.vue"),
  },

  {
    path: "/ranking",
    name: "ranking",
    component: () => import("../views/ranking/index.vue"),
  },
  {
    path: "/guessList",
    name: "guessList",
    component: () => import("../views/ranking/guessList.vue"),
  },
  {
    path: "/certificate1",
    name: "certificate1",
    component: () => import("../views/certificate/certificate1.vue"),
  },
  {
    path: "/certificate2",
    name: "certificate2",
    component: () => import("../views/certificate/certificate2.vue"),
  },
  {
    path: "/lottery",
    name: "lottery",
    component: () => import("../views/lottery/index.vue"),
  },
  {
    path: "/mall",
    name: "mall",
    component: () => import("../views/mall/index.vue"),
  },
  {
    path: "/anchorInfo/:id",
    name: "anchorInfo",
    component: () => import("../views/anchorInfo/index.vue"),
  },
  // 球队详情页面
  {
    path: "/teamInfo",
    name: "teamInfo",
    component: () => import("../views/teamInfo/index.vue"),
  },
  {
    path: "/anchorReplay/:id",
    name: "anchorReplay",
    component: () => import("../views/anchorReplay/index.vue"),
  },
  {
    path: "*",
    redirect: defaultRedirect,
  },
];

const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  routes: routes,
});

// 路由导航守卫 - 控制loading显示
router.beforeEach((to, from, next) => {
  // 显示loading
  store.commit('setRouteLoading', true);
  next();
});

const WC_SCHEDULE_PRESERVE_KEY = "worldcup_schedule_preserve";
const WC_SCHEDULE_CHILD_ROUTE_NAMES = ["scheduleDetail", "liveMatchesTwo"];

router.afterEach((to, from) => {
  const fromName = from && from.name;
  const toName = to && to.name;

  // 离开世界杯页且不是去详情/直播间：取消「返回恢复」标记
  if (fromName === "worldCup" && !WC_SCHEDULE_CHILD_ROUTE_NAMES.includes(toName)) {
    sessionStorage.removeItem(WC_SCHEDULE_PRESERVE_KEY);
  }
  // 从详情/直播间去了非世界杯、非详情链路的页面（如首页）：取消标记
  if (
    WC_SCHEDULE_CHILD_ROUTE_NAMES.includes(fromName) &&
    toName !== "worldCup" &&
    !WC_SCHEDULE_CHILD_ROUTE_NAMES.includes(toName)
  ) {
    sessionStorage.removeItem(WC_SCHEDULE_PRESERVE_KEY);
  }

  // 延迟隐藏loading，确保页面切换完成
  setTimeout(() => {
    store.commit("setRouteLoading", false);
  }, 300);
});

// router.beforeEach((to, from, next) => {
//   // 判断该路由是否需要登录权限
//   if (to.meta.type === "login") {
//     if (localStorage.getItem("userInfo")) {
//       next();
//     } else {
//       next();
//       store.commit("toggleLogin");
//     }
//   next()
// })

//静态资源替换后，刷新页面
router.onError((error) => {
  const jsPattern = /Loading chunk (\S)+ failed/g;
  const cssPattern = /Loading CSS chunk (\S)+ failed/g;
  const isChunkLoadFailed = error.message.match(jsPattern || cssPattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    localStorage.setItem("targetPath", targetPath);
    window.location.reload();
  }
});
//刷新后调整新页面
router.onReady(() => {
  const targetPath = localStorage.getItem("targetPath");
  const tryReload = localStorage.getItem("tryReload");
  if (targetPath) {
    localStorage.removeItem("targetPath");
    if (!tryReload) {
      router.replace(targetPath);
      localStorage.setItem("tryReload", true);
    } else {
      localStorage.removeItem("tryReload");
    }
  }
});

//重复路由
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
